export const positionList = [
  { id: 1, name: "GOALKEEPER", alias: "GK" }, //0
  { id: 2, name: "CENTER BACK", alias: "CB" }, //1
  { id: 3, name: "LEFT SIDE BACK", alias: "LB" }, //2
  { id: 4, name: "RIGHT SIDE BACK", alias: "RB" }, //3
  { id: 5, name: "LEFT WING BACK", alias: "LWB" }, //4
  { id: 6, name: "RIGHT WING BACK", alias: "RWB" }, //5
  { id: 7, name: "DEFENSIVE MIDFIELDER", alias: "CDM" }, //6
  { id: 8, name: "CENTRAL MIDFIELDER", alias: "CM" }, //7
  { id: 9, name: "ATTACKING MIDFIELDER", alias: "CAM" }, //8
  { id: 10, name: "LEFT MIDFIELDER", alias: "LM" }, //9
  { id: 11, name: "RIGHT MIDFIELDER", alias: "RM" }, //10
  { id: 12, name: "LEFT WINGER", alias: "LW" }, //11
  { id: 13, name: "RIGHT WINGER", alias: "RW" }, //12
  { id: 14, name: "LEFT FORWARD", alias: "LF" }, //13
  { id: 15, name: "RIGHT FORWARD", alias: "RF" }, //14
  { id: 16, name: "CENTER FORWARD", alias: "CF" }, //15
  { id: 17, name: "STRIKER", alias: "ST" }, //16
];



 export  const EVENT_MAP = {
    // PASSING - Green tones
    "SP-2": { group: "passing", color: "#10B981", bgColor: "#D1FAE5", label: "Short Pass" },
    "LP-2": { group: "passing", color: "#059669", bgColor: "#D1FAE5", label: "Long Pass" },
    "TB-2": { group: "passing", color: "#047857", bgColor: "#D1FAE5", label: "Through Ball" },
    "C-2":  { group: "passing", color: "#065F46", bgColor: "#D1FAE5", label: "Cross" },
    "SP-3": { group: "passing", color: "#10B981", bgColor: "#D1FAE5", label: "Assist Short Pass" },
    "LP-3": { group: "passing", color: "#059669", bgColor: "#D1FAE5", label: "Assist Long Pass" },
    "TB-3": { group: "passing", color: "#047857", bgColor: "#D1FAE5", label: "Assist Through Ball" },
    "C-3":  { group: "passing", color: "#065F46", bgColor: "#D1FAE5", label: "Assist Cross" },

     "C-0":  { group: "passing", color: "#047857", bgColor: "#D1FAE5", label: "Cross (Unsuccessful)" },
  "C-1":  { group: "passing", color: "#059669", bgColor: "#D1FAE5", label: "Cross (Simple)" },
  "CL-0": { group: "defending", color: "#60A5FA", bgColor: "#DBEAFE", label: "Clearance (Weak)" },
  "CL-3": { group: "defending", color: "#1E3A8A", bgColor: "#DBEAFE", label: "Clearance (Strong)" },
  "GT-2": { group: "goalkeeping", color: "#7C3AED", bgColor: "#EDE9FE", label: "GK Throw" },

    // SHOOTING - Red/Orange tones
    "CS-0": { group: "shooting", color: "#EF4444", bgColor: "#FEE2E2", label: "Off target shot (CS)" },
    "LS-0": { group: "shooting", color: "#DC2626", bgColor: "#FEE2E2", label: "Off target (LS)" },
    "H-0":  { group: "shooting", color: "#B91C1C", bgColor: "#FEE2E2", label: "Off target header" },
    "CS-1": { group: "shooting", color: "#F97316", bgColor: "#FFEDD5", label: "Simple shot" },
    "LS-1": { group: "shooting", color: "#EA580C", bgColor: "#FFEDD5", label: "Simple shot" },
    "H-1":  { group: "shooting", color: "#C2410C", bgColor: "#FFEDD5", label: "Simple header" },
    "CS-2": { group: "shooting", color: "#F59E0B", bgColor: "#FEF3C7", label: "Off the post" },
    "LS-2": { group: "shooting", color: "#D97706", bgColor: "#FEF3C7", label: "Off the post" },
    "H-2":  { group: "shooting", color: "#B45309", bgColor: "#FEF3C7", label: "Off the post header" },
    "CS-3": { group: "shooting", color: "#7C2D12", bgColor: "#FED7AA", label: "Brilliant shot" },
    "LS-3": { group: "shooting", color: "#7C2D12", bgColor: "#FED7AA", label: "Brilliant shot" },
    "H-3":  { group: "shooting", color: "#7C2D12", bgColor: "#FED7AA", label: "Brilliant header" },
    "CS-4": { group: "shooting", color: "#991B1B", bgColor: "#FECACA", label: "Goal" },
    "LS-4": { group: "shooting", color: "#991B1B", bgColor: "#FECACA", label: "Goal" },
    "H-4":  { group: "shooting", color: "#991B1B", bgColor: "#FECACA", label: "Goal header" },

    // DEFENDING - Blue tones
    "IN-2": { group: "defending", color: "#3B82F6", bgColor: "#DBEAFE", label: "Interception" },
    "CL-2": { group: "defending", color: "#2563EB", bgColor: "#DBEAFE", label: "Clearance" },
    "ST-2": { group: "defending", color: "#1D4ED8", bgColor: "#DBEAFE", label: "Standing tackle" },
    "SL-2": { group: "defending", color: "#1E40AF", bgColor: "#DBEAFE", label: "Sliding tackle" },

    // GOALKEEPING - Purple/Amber tones
    "GS-0": { group: "goalkeeping", color: "#8B5CF6", bgColor: "#EDE9FE", label: "Save Level 0" },
    "GS-1": { group: "goalkeeping", color: "#7C3AED", bgColor: "#EDE9FE", label: "Save Level 1" },
    "GS-2": { group: "goalkeeping", color: "#6D28D9", bgColor: "#EDE9FE", label: "Save Level 2" },
    "GS-3": { group: "goalkeeping", color: "#5B21B6", bgColor: "#EDE9FE", label: "Save Level 3" },
    "GH-0": { group: "goalkeeping", color: "#D97706", bgColor: "#FEF3C7", label: "GK Handling 0" },
    "GH-1": { group: "goalkeeping", color: "#B45309", bgColor: "#FEF3C7", label: "GK Handling 1" },
    "GH-2": { group: "goalkeeping", color: "#92400E", bgColor: "#FEF3C7", label: "GK Handling 2" },
  };
